import React from 'react';
import { LoadingIndicator } from 'ui-components/components/loading-indicator';
import style from './v2-placeholder-page.module.less';

export const v2PlaceholderPage = () => <LoadingIndicator className={style['v2-loading-indicator']} />;
